import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, Required } from '@hvlng/framework-bff/core';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { PerWorkSubareaTextModel } from './per-work-subarea-text-model';
import { PerWorkAreaModel } from './per-work-area-model';

@JsonObject('KovanHrPerWorkSubareaModel')
export class PerWorkSubareaModel extends HvlBaseModel {
    @JsonProperty('workSubareaText', PerWorkSubareaTextModel, true)
    workSubareaText: PerWorkSubareaTextModel = null;

    @Required()
    @JsonProperty('workSubareaTextId', Number, true)
    workSubareaTextId: number = null;

    @Required()
    @JsonProperty('perWorkAreaId', Number, true)
    perWorkAreaId: number = null;

    @EmptyControl()
    @JsonProperty('perWorkArea', PerWorkAreaModel, true)
    perWorkArea: PerWorkAreaModel = null;

    @Required()
    @JsonProperty('genCountryUuid', String, true)
    genCountryUuid: string = null;
}
